import { BigNumber } from "ethers";

import FlexacoinABI from "../contracts/Flexacoin.abi.json";

const DECIMALS = BigNumber.from("18");
const DECIMALS_FACTOR = BigNumber.from("10").pow(DECIMALS);

type Numberish = BigNumber | number | string;

const toChain = (amount: Numberish) => {
  if (!BigNumber.isBigNumber(amount)) {
    amount = BigNumber.from(amount);
  }
  return BigNumber.from(amount).mul(DECIMALS_FACTOR);
};

// BigNumber.set({
//   ROUNDING_MODE: BigNumber.ROUND_DOWN,
// })

const toDecimal = (amount: Numberish) => {
  if (!BigNumber.isBigNumber(amount)) {
    amount = BigNumber.from(amount);
  }
  if (amount.isZero()) {
    return BigNumber.from(0);
  }
  const a = amount.div(DECIMALS_FACTOR);
  return a;
};

const Flexacoin = {
  symbol: "FXC",
  decimals: 18,
  decimalsFactor: DECIMALS_FACTOR,
  abi: FlexacoinABI.abi,

  toDecimal,
  toChain,
};

export default Flexacoin;

// export const tokensToStr = (amount: number | BigNumber) => {
//   const a = new BN(amount)
//   const res = a.div(DECIMALS_FACTOR)
//   let str = res.div.toString()

//   if (res.mod.isZero()) {
//     return str
//   }

//   str += `.${res.mod.toString(10, 18)}`

//   while (str.endsWith('0')) {
//     str = str.substring(0, str.length - 1)
//   }

//   return str
// }
